module.exports = __webpack_public_path__ + "img/laravel.efb5ca0b.svg";